package com.evoapps.evoshift.viewmodels

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.evoapps.evoshift.domain.model.KioskSession
import com.evoapps.evoshift.domain.usecase.auth.GetCurrentUserUseCase
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.launch
import com.evoapps.evoshift.domain.usecase.auth.CheckEmailVerificationUseCase

sealed interface RootState {
    data object Loading : RootState
    data class LoggedIn(val isSetupComplete: Boolean, val isEmailVerified: Boolean) : RootState
    data object NotLoggedIn : RootState

    /** SH-107: this device is a workplace's clock-in tablet (a device identity, not a person). */
    data class Kiosk(val session: KioskSession) : RootState
}

class RootViewModel(
    private val getCurrentUserUseCase: GetCurrentUserUseCase,
    private val checkEmailVerificationUseCase: CheckEmailVerificationUseCase,
    /** The paired tablet's session (KioskRepository.observeSession); none on a person's device. */
    private val kioskSessions: Flow<KioskSession?> = flowOf(null)
) : ViewModel() {

    private val _state = MutableStateFlow<RootState>(RootState.Loading)
    val state = _state.asStateFlow()

    init {
        checkAuthStatus()
    }

    private fun checkAuthStatus() {
        viewModelScope.launch {
            combine(kioskSessions, getCurrentUserUseCase()) { kiosk, user -> kiosk to user }.collect { (kiosk, user) ->
                _state.value = when {
                    // A tablet has no profile (the user flow is null for it): the kiosk takes over.
                    kiosk != null -> RootState.Kiosk(kiosk)
                    user != null -> RootState.LoggedIn(user.isSetupComplete, checkEmailVerificationUseCase().getOrDefault(false))
                    else -> RootState.NotLoggedIn
                }
            }
        }
    }
}
